import React from "react";
import styled from "styles/styled_components";
import THEME from "styles/theme";
import Icon, { ICON_TYPE } from "components/shared/icon";
import { sortType } from "interfaces/sort_type";
import { parseNameColors, IColorProps } from "helpers/colors";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  width: 100%;
  height: ${({ theme }) => `calc(4 * ${theme.gridBase})`};
  justify-content: flex-start;
  align-items: flex-end;
  cursor: pointer;
  padding: 0 0 0 5px;
  background-color: ${({ theme }) => theme.colors.brandWhite};
  :hover {
    background-color: ${({ theme }) => theme.colors.brandBlue10};
  }
`;

const SorterOption = styled.li`
  display: flex;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.brandWhite};
  border-radius: ${({ theme }) => theme.borderRadius};
  flex-direction: row;
  justify-content: space-between;
  padding: ${({ theme }) => `5px ${theme.gridBase}`};
`;

const Stack = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Text = styled.p<ITextStyleProps>`
  text-align: ${({ right }) => (right ? "right" : "left")};
  padding: 0px 10px;
  font-size: ${({ theme }) => theme.text.size.base};
  line-height: ${({ theme }) => theme.text.lineHeight.small};
  font-weight: bold;
`;

const InvertedIcon = styled(Icon)`
  transform: rotate(180deg);
`;

const Toggler = ({
  onClick,
  label,
  right,
  classes,
  colors: { up, down },
}: ITogglerProps) => {
  const onNoPropagationClick = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    event.stopPropagation();
    return onClick();
  };

  return (
    <Wrapper onClick={onNoPropagationClick} className={classes}>
      <Stack className={classes}>
        <InvertedIcon
          color={up}
          type={ICON_TYPE.CHEVRON_DOWN}
          size={THEME.iconSize.tiny}
        />
        <Icon
          color={down}
          type={ICON_TYPE.CHEVRON_DOWN}
          size={THEME.iconSize.tiny}
        />
      </Stack>
      <Text className={classes} right={right}>
        {label}
      </Text>
    </Wrapper>
  );
};

const Sorter = ({ isExpanded, sortByName, status }: ISorterProps) => {
  if (isExpanded) {
    const nameColors = parseNameColors(status);
    return (
      <SorterOption>
        <Toggler
          classes="toggler name"
          onClick={sortByName}
          label="EMPLOYEE"
          colors={nameColors}
        />
      </SorterOption>
    );
  }

  return null;
};

interface ISorterProps {
  isExpanded: boolean;
  sortByName: () => void;
  status: sortType;
}

interface ITogglerProps {
  classes?: string;
  onClick: () => void;
  label: string;
  right?: boolean;
  colors: IColorProps;
}

interface ITextStyleProps {
  right?: boolean;
}

export default Sorter;
